import React from 'react';

import LoadingIndicator from '@dashboard/components/loading/LoadingIndicator';
import BaseSettingCard from '@dashboard/components/platform-settings/BaseSettingCard';
import { useDomainNameVerificationsQuery } from '@dashboard/generated/wp/platform';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';

import CreateDomainNameVerification from './CreateDomainNameVerification';
import DomainNameRow from './DomainNameRow';

export default function VerifiedDomainsList() {
  const { data } = useDomainNameVerificationsQuery();
  const actions = <CreateDomainNameVerification />;
  const DOMAINS_HELP_URL = 'https://www.usewaypoint.com/docs/verified-domains';

  const nodes = data?.DomainNameVerifications.nodes;

  if (nodes === undefined) {
    return (
      <BaseSettingCard helpUrl={DOMAINS_HELP_URL} title="Verified domains" actions={actions}>
        <LoadingIndicator />
      </BaseSettingCard>
    );
  }

  if (nodes.length === 0) {
    return (
      <BaseSettingCard helpUrl={DOMAINS_HELP_URL} title="Verified domains" actions={actions}>
        <Typography color="text.secondary">
          A verified and approved domain is required to start sending live emails.
        </Typography>
      </BaseSettingCard>
    );
  }

  return (
    <BaseSettingCard helpUrl={DOMAINS_HELP_URL} title="Verified domains" actions={actions}>
      <TableContainer>
        <Table sx={{ 'td, th': { px: 0, py: 1, border: 0 } }}>
          <TableHead>
            <TableRow>
              <TableCell variant="head">Name</TableCell>
              <TableCell variant="head" sx={{ width: 192 }}>
                DNS verification
              </TableCell>
              <TableCell variant="head">Waypoint approval</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {nodes.map((row) => (
              <DomainNameRow key={row.id} model={row} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </BaseSettingCard>
  );
}
